AccessController = App.loadClass 'admin::Angular/AccessController'
ChemicalsValidator = App.loadClass 'admin::Angular/Tools/ChemicalsValidator'

class exports.ChemicalsController extends AccessController
    # This is the only time you ever want to use a skinny arrow. Every other function call should use a fat arrow.
    constructor: (@scope, @transitions, @modal, @chemicalsService, @q, @loading, @http) ->
        super('chemicals', @http)

        clonableSpan = document.createElement 'SPAN'
        hot = window.Handsontable
        @scope.chemRenderer = (instance, td, row, col, prop, value, cellProperties) =>
            chemical = @scope.chemicals[row]
            hot.Dom.empty td
            eventManager = hot.eventManager instance

            wrapperSpan = clonableSpan.cloneNode false
            wrapperSpan.className = 'clickable text-center block label'
            innerSpan = clonableSpan.cloneNode false
            innerSpan.className = 'fa'
            wrapperSpan.appendChild innerSpan

            if chemical.children?.length
                wrapperSpan.classList.add 'label-info'
                innerSpan.classList.add 'fa-pencil'
            else
                wrapperSpan.classList.add 'label-success'
                innerSpan.classList.add 'fa-plus'

            if chemical.parents?.length or not chemical.id?
                wrapperSpan.classList.add 'btn', 'disabled'
            if chemical.parents?.length
                wrapperSpan.title = 'Cannot add children when already a child'
            if not chemical.id?
                wrapperSpan.title = 'Cannot add children until after new chemical is saved'

            eventManager.addEventListener wrapperSpan, 'click', (event) =>
                # Don't let you add children if this chemical already has a parent or hasn't been saved yet
                return if chemical.parents?.length or not chemical.id?
                @modal.open
                    windowClass: 'medium_dialog'
                    templateUrl: 'backend/admin/new-tools/chemicals/children-dialog'
                    controller: 'Tools.Controllers.ChemicalsChildrenController'
                    resolve:
                        chemical: () -> chemical
                        chemicals: () => @scope.chemicals
                .result.then (chemical) =>
                    @scope.chemicals[row] = chemical
                    @buildParentData()
                    @disableCellsThatNeedTo()

            # Prevent cell from being selected
            eventManager.addEventListener wrapperSpan, 'mousedown', (event) ->
                hot.helper.stopPropagation event

            td.appendChild wrapperSpan
            return td

        @scope.fullpage = true
        @scope.title = 'Chemicals'
        @scope.chemicals = []
        @scope.chemicalsNotChanged = false
        @scope.loadChemicals = @loadChemicals
        @scope.saveChemicals = @saveChemicals
        @validator = null
        @scope.validateName = @doNameValidation
        @scope.validateWindSpeed = @doWindSpeedValidation
        @scope.validateModeOfAction = @doModeOfActionValidation
        @scope.validateCategory = @doCategoryValidation

        # Load all the chemical data
        @loadChemicals()

        self = this

        # handsontable configuration
        @scope.hot_settings =
            currentColClassName: 'highlighted'
            currentRowClassName: 'highlighted'
            # invalidCellClassName: 'invalid'
            allowInsertColumn: false
            allowRemoveColumn: false
            minSpareRows: 1
            allowInsertRow: true
            allowRemoveRow: false
            rowHeaders: false
            columnHeaders: true
            fixedRowsTop: 0
            beforeValidate: @beforeValidate # register our custom beforeValidate hook
            allowInvalid: true # don't automatically clear invalid cells
            dataSchema:
                is_product: true

            # hooks
            afterInit: ->
                # `this` is the HoT instance (the `Core` object)
                # this is why, this is why, this is why I'm hot
                self.hot = this

                self.validator = new ChemicalsValidator(this, self.scope.chemicals)

                self.disableCellsThatNeedTo()

    doNameValidation: (cell, callback) =>
        @validator.validateName(cell, callback)

    doWindSpeedValidation: (cell, callback) =>
        @validator.validateWindSpeed(cell, callback)

    doModeOfActionValidation: (cell, callback) =>
        @validator.validateModeOfAction(cell, callback)

    doCategoryValidation: (cell, callback) =>
        @validator.validateCategory(cell, callback)

    loadChemicals: () =>
        @chemicalsService.getAllChemicals().then (response) =>
            # Tried using concat here to preserve empty row but it broke things for some reason
            _.merge @scope.chemicals, response.data

            if @scope.chemicals[@scope.chemicals.length - 1].name
                @scope.chemicals.push
                    is_product: true
            @buildParentData()

    buildParentData: () =>
        # Do things for parents
        for chemical in @scope.chemicals
            if chemical.children?.length
                chemical.max_wind_speed = chemical.children
                .map (child) -> child.max_wind_speed
                .reduce (min, child) ->
                    return child if min is null
                    return min if child is null
                    return Math.min min, child
                , Infinity
                if chemical.max_wind_speed is Infinity
                    chemical.max_wind_speed = null

    saveChemicals: () =>
        @loading.overMap('Saving...')
        @validator.is_valid = true
        @validator.validation_messages = []
        @hot.validateCells _.debounce () =>
            if @validator.is_valid
                # Sanitize our data to not save blank rows
                sanitizedChemicals = @sanitizeChemicals(@scope.chemicals)
                # Save the data through the service/php controller
                $save_promise = @loadScopeData(@chemicalsService.actuallySaveChemicals(sanitizedChemicals))
                $save_promise.then (promise_result) =>
                    # Then reload the data so sorting is good.
                    @loadChemicals().then () =>
                        @loading.hideAll()
                        @clearAlert()
            else
                # Display the error messages back to the user.
                @setAlert({ type: 'error' }, @validator.validation_messages)
                @loading.hideAll()
        , 1000
        return

    sanitizeChemicals: (unsanitizedChemicals) =>
        sanitizedChemicals = []
        for unsanitizedChemical in unsanitizedChemicals
            if unsanitizedChemical.name isnt '' and unsanitizedChemical.name isnt null
                if unsanitizedChemical.mode_of_action is ''
                    unsanitizedChemical.mode_of_action = null
                if unsanitizedChemical.max_wind_speed is ''
                    unsanitizedChemical.max_wind_speed = null
                if unsanitizedChemical.children?.length
                    unsanitizedChemical.mode_of_action = null
                sanitizedChemicals.push(unsanitizedChemical)
        return sanitizedChemicals

    beforeValidate: (value, row, prop, source) =>
        # This gives us additional cell info when validating so we can do useful
        # things with it. Validator functions will now receive this object instead
        # of just a string value.
        cell =
            value: value
            row: row
            prop: prop
        # ignore the last row because it's always empty
        if row is @hot.countRows() - 1
            cell.ignore = true

        rowObject = @hot.getSourceDataAtRow(row)
        if not rowObject.name and
                not rowObject.category and
                not rowObject.mode_of_action and
                not rowObject.epa_number and
                not rowObject.max_wind_speed and
                not rowObject.data_source
            cell.ignore = true
        return cell

    disableCellsThatNeedTo: () =>
        @hot.updateSettings
            cells: (row, col, prop) =>
                cellProperties = {}
                if @scope.chemicals[row].children?.length
                    if prop is 'category' or prop is 'mode_of_action' or prop is 'max_wind_speed'
                        cellProperties.readOnly = true
                if prop is 'category'
                    if @scope.chemicals[row].parents?.length or @scope.chemicals[row].children?.length
                        cellProperties.readOnly = true
                    else
                        cellProperties.readOnly = false
                return cellProperties
